<template>
  <v-navigation-drawer
    app
    permanent
    :class="{ 'trigger-app-menu': $store.state.isTriggerAppMenu }"
    style="top: 4rem !important; bottom: 0; 
    left: 0;
    height: auto !important;
    max-height: 100vh;
    color: #6C6C6C;
    transition-property: none !important;
    "
    :style="{'width': sideBarWidth }"
    floating
  >
    <IStoreSidebarNav />
  </v-navigation-drawer>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import IStoreSidebarNav from './IStoreSidebarNav'
import Version from '@/scripts/version'
import { Subversion } from '@/scripts/version'

export default {
  name: 'AppSidebar',
  components: {
    IStoreSidebarNav
  },
  props:{
    sideBarWidth: String
  },
  setup() {
    const store = useStore()
    return {
      version: Version,
      sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
      sidebarVisible: computed(() => store.state.sidebarVisible),
      isOver: false,
    }
  },
  computed: {
    getVersion() {
      if (Subversion) {
        return Version + '-' + Subversion
      } else {
        return Version
      }
    }
  },
}
</script>
<style scoped lang="scss">
.trigger-app-menu {
  position: absolute !important;
  top: 0;
  margin-left: 0 !important;
  width: 0px !important;
}
</style>